(function() {
  var STORAGE_KEY = 'tsn_cart_terms_agreed_at';
  var EXPIRY_MS = 15 * 60 * 1000; // 15 minutes

  function isAgreementFresh() {
    try {
      var ts = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if (!ts) return false;
      return (Date.now() - ts) < EXPIRY_MS;
    } catch (e) { return false; }
  }

  function rememberAgreement() {
    try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch (e) {}
  }

  function clearAgreement() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // Force the Clean Canvas cart-drawer to re-measure its sticky footer height
  // after we show/hide the warning message.
  function remeasureDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // Give the browser a tick to render the warning, then recalculate.
    requestAnimationFrame(function() {
      var summary = drawer.querySelector('.cart-drawer__summary');
      var buttons = drawer.querySelector('.cart-drawer__checkout-buttons');
      if (summary) {
        drawer.style.setProperty('--cart-drawer__summary-height', summary.offsetHeight + 'px');
      }
      if (buttons) {
        drawer.style.setProperty('--cart-drawer__checkout-buttons-height', buttons.offsetHeight + 'px');
      }
      // Also trigger a resize event in case the theme listens for it
      window.dispatchEvent(new Event('resize'));
    });
  }

  // Auto-tick any terms checkbox on the page if agreement is fresh
  function syncCheckboxes() {
    var fresh = isAgreementFresh();
    var boxes = document.querySelectorAll('#cart-terms, .js-cart-terms-checkbox');
    boxes.forEach(function(b) {
      if (fresh && !b.checked) {
        b.checked = true;
        b.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    var warning = document.querySelector('.cart-drawer__terms-warning');
    if (warning && fresh) {
      warning.hidden = true;
      remeasureDrawer();
    }
  }

  document.addEventListener('DOMContentLoaded', syncCheckboxes);

  // Re-sync when the cart drawer opens
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="open-drawer"], .js-open-drawer, [href="#cart-drawer"], .header__cart-link, .js-toggle-cart-drawer')) {
      setTimeout(function() {
        syncCheckboxes();
        remeasureDrawer();
      }, 100);
    }
  });

  // When ANY terms checkbox is ticked, remember it
  document.addEventListener('change', function(e) {
    if (e.target && (e.target.id === 'cart-terms' || e.target.classList.contains('js-cart-terms-checkbox'))) {
      if (e.target.checked) {
        rememberAgreement();
        syncCheckboxes();
        var warning = document.querySelector('.cart-drawer__terms-warning');
        if (warning) {
          warning.hidden = true;
          remeasureDrawer();
        }
      } else {
        clearAgreement();
      }
    }
  });

  // Gate any drawer link that requires agreement
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.js-drawer-checkout-link');
    if (!link) return;
    if (isAgreementFresh()) return;
    var checkbox = document.querySelector('#cart-terms');
    if (checkbox && checkbox.checked) {
      rememberAgreement();
      return;
    }
    e.preventDefault();
    var warning = document.querySelector('.cart-drawer__terms-warning');
    if (warning) {
      warning.hidden = false;
      remeasureDrawer();
    }
    if (checkbox) checkbox.focus();
  });

  // Clear the flag once an order is placed
  if (/\/(thank_you|orders\/)/.test(window.location.pathname)) {
    clearAgreement();
  }
})();